export const translations = {
  // Titles
  'Financial Analytics': { en: 'Financial Analytics', zh: '金融分析' },

  // Sidebar
  'Dashboard': { en: 'Dashboard', zh: '仪表板' },
  'Fraud Detection': { en: 'Fraud Detection', zh: '欺诈检测' },
  'Risk Assessment': { en: 'Risk Assessment', zh: '风险评估' },
  'Financial Forecasting': { en: 'Financial Forecasting', zh: '财务预测' },
  'Portfolio Analytics': { en: 'Portfolio Analytics', zh: '投资组合分析' },
  'Settings': { en: 'Settings', zh: '设置' },
  'Return to Portal': { en: 'Return to Portal', zh: '返回门户' },

  // Dashboard Page
  'Welcome to your Financial Dashboard': { en: 'Welcome to your Financial Dashboard', zh: '欢迎来到您的财务仪表板' },
  'Overview of key financial metrics and performance indicators.': { en: 'Overview of key financial metrics and performance indicators.', zh: '关键财务指标和绩效指标概述.' },
  'Total Revenue': { en: 'Total Revenue', zh: '总收入' },
  'Net Profit': { en: 'Net Profit', zh: '净利润' },
  'Operating Expenses': { en: 'Operating Expenses', zh: '运营支出' },
  'Cash Flow': { en: 'Cash Flow', zh: '现金流' },
  'Revenue vs Profit Trend': { en: 'Revenue vs Profit Trend', zh: '收入与利润趋势' },
  'Operating Expenses Breakdown': { en: 'Operating Expenses Breakdown', zh: '运营支出明细' },
  'vs last month': { en: 'vs last month', zh: '与上月相比' },

  // Fraud Detection Page
  'Suspicious Activities': { en: 'Suspicious Activities', zh: '可疑活动' },
  'Last 24 Hours': { en: 'Last 24 Hours', zh: '过去24小时' },
  'Under Investigation': { en: 'Under Investigation', zh: '调查中' },
  'Active Cases': { en: 'Active Cases', zh: '活跃案例' },
  'Prevention Rate': { en: 'Prevention Rate', zh: '预防率' },
  'vs Last Month': { en: 'vs Last Month', zh: '与上月相比' },
  'High Priority Alerts': { en: 'High Priority Alerts', zh: '高优先级警报' },
  'Requires Action': { en: 'Requires Action', zh: '需要采取行动' },
  'Fraud Activity Trends': { en: 'Fraud Activity Trends', zh: '欺诈活动趋势' },
  'Fraud Types Distribution': { en: 'Fraud Types Distribution', zh: '欺诈类型分布' },
  'Recent Fraud Alerts': { en: 'Recent Fraud Alerts', zh: '最近的欺诈警报' },
  'Suspicious Transaction Pattern': { en: 'Suspicious Transaction Pattern', zh: '可疑交易模式' },
  'Multiple high-value transactions detected from unusual locations': { en: 'Multiple high-value transactions detected from unusual locations', zh: '从异常位置检测到多笔高价值交易' },
  'Potential Account Compromise': { en: 'Potential Account Compromise', zh: '潜在账户泄露' },
  'Unusual login activity detected from multiple IP addresses': { en: 'Unusual login activity detected from multiple IP addresses', zh: '从多个IP地址检测到异常登录活动' },
  'Identity Verification Failed': { en: 'Identity Verification Failed', zh: '身份验证失败' },
  'Multiple failed verification attempts for high-risk transaction': { en: 'Multiple failed verification attempts for high-risk transaction', zh: '高风险交易的多次验证尝试失败' },

  // Risk Assessment Page
  'Overall Risk Score': { en: 'Overall Risk Score', zh: '总体风险评分' },
  'Moderate Risk Level': { en: 'Moderate Risk Level', zh: '中等风险水平' },
  'Market Volatility': { en: 'Market Volatility', zh: '市场波动' },
  'Increase': { en: 'Increase', zh: '增加' },
  'Compliance Status': { en: 'Compliance Status', zh: '合规状态' },
  'Within Limits': { en: 'Within Limits', zh: '在限制范围内' },
  'Risk Alerts': { en: 'Risk Alerts', zh: '风险警报' },
  'Require Attention': { en: 'Require Attention', zh: '需要关注' },
  'Risk Trends': { en: 'Risk Trends', zh: '风险趋势' },
  'Risk Category Analysis': { en: 'Risk Category Analysis', zh: '风险类别分析' },
  'Active Risk Alerts': { en: 'Active Risk Alerts', zh: '活跃风险警报' },
  'High Credit Exposure': { en: 'High Credit Exposure', zh: '高信用风险敞口' },
  'Credit exposure in sector X exceeds threshold by 15%': { en: 'Credit exposure in sector X exceeds threshold by 15%', zh: 'X行业的信用风险敞口超出阈值15%' },
  'Market Volatility Warning': { en: 'Market Volatility Warning', zh: '市场波动警告' },
  'Increased volatility detected in Asian markets': { en: 'Increased volatility detected in Asian markets', zh: '亚洲市场检测到波动性增加' },
  'Liquidity Alert': { en: 'Liquidity Alert', zh: '流动性警报' },
  'Short-term liquidity ratio approaching minimum threshold': { en: 'Short-term liquidity ratio approaching minimum threshold', zh: '短期流动性比率接近最低阈值' },

  // Financial Forecasting Page
  'Projected Growth': { en: 'Projected Growth', zh: '预计增长' },
  'Next Quarter': { en: 'Next Quarter', zh: '下个季度' },
  'Revenue Target': { en: 'Revenue Target', zh: '收入目标' },
  'End of Year': { en: 'End of Year', zh: '年末' },
  'Market Position': { en: 'Market Position', zh: '市场地位' },
  'Above Market': { en: 'Above Market', zh: '高于市场' },
  'Cost Optimization': { en: 'Cost Optimization', zh: '成本优化' },
  'Projected Savings': { en: 'Projected Savings', zh: '预计节省' },
  'Revenue Forecast': { en: 'Revenue Forecast', zh: '收入预测' },
  'Expense Projections': { en: 'Expense Projections', zh: '支出预测' },
  'Market Trend Analysis': { en: 'Market Trend Analysis', zh: '市场趋势分析' },
  'Scenario Analysis': { en: 'Scenario Analysis', zh: '情景分析' },
  'Optimistic Scenario': { en: 'Optimistic Scenario', zh: '乐观情景' },
  'Market expansion leads to 20% growth': { en: 'Market expansion leads to 20% growth', zh: '市场扩张带来20%的增长' },
  'Probability': { en: 'Probability', zh: '概率' },
  'Base Scenario': { en: 'Base Scenario', zh: '基本情景' },
  'Steady growth continues at 15%': { en: 'Steady growth continues at 15%', zh: '稳定增长持续在15%' },
  'Conservative Scenario': { en: 'Conservative Scenario', zh: '保守情景' },
  'Market slowdown reduces growth to 8%': { en: 'Market slowdown reduces growth to 8%', zh: '市场放缓使增长减少到8%' },

  // Portfolio Analytics Page
  'Total Return': { en: 'Total Return', zh: '总回报' },
  'YTD Performance': { en: 'YTD Performance', zh: '年初至今表现' },
  'Risk Score': { en: 'Risk Score', zh: '风险评分' },
  'Moderate Risk': { en: 'Moderate Risk', zh: '中等风险' },
  'Diversification': { en: 'Diversification', zh: '多元化' },
  'Well Diversified': { en: 'Well Diversified', zh: '良好多元化' },
  'Alpha Generated': { en: 'Alpha Generated', zh: '产生的Alpha' },
  'Above Benchmark': { en: 'Above Benchmark', zh: '高于基准' },
  'Performance Tracking': { en: 'Performance Tracking', zh: '业绩跟踪' },
  'Asset Allocation': { en: 'Asset Allocation', zh: '资产配置' },
  'Risk Metrics': { en: 'Risk Metrics', zh: '风险指标' },
  'Portfolio Optimization': { en: 'Portfolio Optimization', zh: '投资组合优化' },
  'Rebalancing Opportunity': { en: 'Rebalancing Opportunity', zh: '再平衡机会' },
  'Stock allocation is 5% above target': { en: 'Stock allocation is 5% above target', zh: '股票配置比目标高出5%' },
  'Suggested Action: Reduce equity exposure': { en: 'Suggested Action: Reduce equity exposure', zh: '建议操作：减少股票敞口' },
  'Diversification Suggestion': { en: 'Diversification Suggestion', zh: '多元化建议' },
  'Consider adding emerging market exposure': { en: 'Consider adding emerging market exposure', zh: '考虑增加新兴市场敞口' },
  'Target: 5-10% allocation': { en: 'Target: 5-10% allocation', zh: '目标：5-10%的配置' },
  'Risk Management': { en: 'Risk Management', zh: '风险管理' },
  'Portfolio beta slightly high': { en: 'Portfolio beta slightly high', zh: '投资组合beta值略高' },
  'Consider defensive stocks or bonds': { en: 'Consider defensive stocks or bonds', zh: '考虑防御性股票或债券' },
};

export type TranslationKey = keyof typeof translations;

const getTranslation = (key: TranslationKey, language: 'en' | 'zh'): string => {
  const translation = translations[key];
  if (translation) {
    return translation[language];
  }
  console.warn(`Translation not found for key: ${key}`);
  return key as string; // Fallback to key
};

export default getTranslation; 